import { useState, useEffect, useCallback } from "react";
export function useStore(store, options) {
    const [state, setState] = useState(() => {
        return {
            state: store.state,
            prevState: undefined
        };
    });
    const handleStateChange = useCallback((storeState, prevStoreState) => {
        setState({ state: storeState, prevState: prevStoreState });
    }, []);
    useEffect(() => {
        store.subscribe(handleStateChange);
        return () => {
            store.unsubscribe(handleStateChange);
            if (options && options.reset)
                store.reset();
        };
    }, []);
    return {
        state: state.state,
        setState: store.setState,
        prevState: state.prevState,
        initialState: store.initialState,
        reset: store.reset
    };
}
//# sourceMappingURL=useStore.js.map